import { nameValueArrayFromObject } from './utils.js';
export const namePrefixDisplay = {
    DR: 'Dr.',
    MR: 'Mr.',
    MRS: 'Mrs.',
    MS: 'Ms.',
    MX: 'Mx.',
};
export const namePrefixes = nameValueArrayFromObject(namePrefixDisplay);
//# sourceMappingURL=namePrefixes.js.map